var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CellByCell',{attrs:{"sameCell":"true"},scopedSlots:_vm._u([{key:"default",fn:function({i, j}){return [_c('BooleanCell',{attrs:{"i":i,"j":j}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }